/* Cupido KSA theme script. Small on purpose: no libraries, nothing runs on scroll except one
   IntersectionObserver for the sticky bar and a passive scroll listener on the gallery strip. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- countdown to the daily cut-off (Riyadh time, UTC+3) ---------- */
  function riyadhNow() { var d = new Date(); return new Date(d.getTime() + (d.getTimezoneOffset() + 180) * 60000); }
  function tick() {
    $$('[data-cp-cutoff]').forEach(function (el) {
      var h = parseInt(el.getAttribute('data-cp-cutoff'), 10) || 14;
      var now = riyadhNow(), end = new Date(now);
      end.setHours(h, 0, 0, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      var H = $('[data-h]', el), M = $('[data-m]', el), S = $('[data-s]', el);
      if (H) H.textContent = p(Math.floor(s / 3600));
      if (M) M.textContent = p(Math.floor(s % 3600 / 60));
      if (S) S.textContent = p(s % 60);
    });
  }
  if ($('[data-cp-cutoff]')) { tick(); setInterval(tick, 1000); }

  /* ---------- menu drawer ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cp-open]');
    if (o) { var d = document.getElementById(o.getAttribute('data-cp-open')); if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); } return; }
    if (e.target.closest('[data-cp-close]')) { var dr = e.target.closest('.cp-drawer'); if (dr) { dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true'); } }
  });

  /* ---------- click-to-play video ---------- */
  $$('[data-cp-video]').forEach(function (box) {
    var b = $('.cp-video__play', box), t = $('template', box);
    if (!b || !t) return;
    b.addEventListener('click', function () {
      box.innerHTML = t.innerHTML;
      var v = $('video', box); if (v) { v.muted = false; v.play && v.play().catch(function () {}); nmSync(v); }
    });
  });

  /* ---------- product videos: no controls, no mute. Tap = play/pause, sound always on ---------- */
  function nmSync(v) { var w = v.parentElement; if (w) w.classList.toggle('cp-nm-paused', v.paused); }
  document.addEventListener('click', function (e) {
    var v = e.target.closest('video.cp-nomute') || (e.target.closest('.cp-nm-paused') && $('video.cp-nomute', e.target.closest('.cp-nm-paused')));
    if (!v) return;
    e.preventDefault();
    v.muted = false; if (v.volume < 1) v.volume = 1;
    if (v.paused) v.play().catch(function () {}); else v.pause();
  });
  ['play', 'pause', 'ended', 'loadedmetadata'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (e.target.matches && e.target.matches('video.cp-nomute')) nmSync(e.target); }, true);
  });
  document.addEventListener('volumechange', function (e) {
    var v = e.target; if (v.matches && v.matches('video.cp-nomute') && (v.muted || v.volume < 1)) { v.muted = false; v.volume = 1; }
  }, true);
  $$('video.cp-nomute').forEach(nmSync);

  /* ---------- delivery dates (no Friday) ---------- */
  $$('[data-cp-ship]').forEach(function (el) {
    var fmt;
    try { fmt = new Intl.DateTimeFormat('ar-SA-u-nu-latn-ca-gregory', { weekday: 'long', day: 'numeric', month: 'long' }); }
    catch (e) { fmt = { format: function (d) { return d.toLocaleDateString(); } }; }
    var add = function (n) { var d = riyadhNow(); var k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 5) k++; } return d; };
    var min = parseInt(el.getAttribute('data-min'), 10) || 2, max = parseInt(el.getAttribute('data-max'), 10) || 5;
    var d1 = $('[data-d1]', el), d2 = $('[data-d2]', el);
    if (d1) d1.textContent = fmt.format(add(1));
    if (d2) d2.textContent = fmt.format(add(min)).split('،')[0] + ' - ' + fmt.format(add(max));
  });

  /* ---------- cart drawer: quantity, remove, protection, upsell ---------- */
  function cartPost(url, body) {
    var dr = document.querySelector('cart-drawer'), inner = dr && dr.querySelector('.drawer__inner');
    if (inner) inner.classList.add('is-busy');
    body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (dr && j.sections) dr.renderContents(j); else location.reload(); cpSubSync(); })
      .catch(function () { location.reload(); });
  }
  /* Seal add-on sync (like sp-addon-sync in Sport Plus): protection + free delivery renew with the perfume
     when a subscription line is in the cart, and turn back to one-time when it is not */
  var syncing = false;
  function cpSubSync() {
    var ad = window.cpSubAddons || []; if (!ad.length || syncing) return Promise.resolve();
    syncing = true;
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var isAd = function (vid) { return ad.filter(function (a) { return a.v === vid; })[0]; };
      var sub = c.items.some(function (i) { return !isAd(i.variant_id) && i.selling_plan_allocation; });
      var fix = null;
      c.items.forEach(function (i) {
        var a = isAd(i.variant_id); if (!a || fix) return;
        var cur = i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null, want = sub ? a.p : null;
        if (cur !== want) fix = { id: i.key, quantity: i.quantity, selling_plan: want };
      });
      syncing = false;
      if (fix) return cartPost('/cart/change.js', fix);
    }).catch(function () { syncing = false; });
  }
  window.cpSubSync = cpSubSync;
  cpSubSync();
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cp-qty]');
    if (q) { e.preventDefault(); cartPost('/cart/change.js', { id: q.getAttribute('data-cp-qty'), quantity: Math.max(0, +q.getAttribute('data-q')) }); return; }
    var a = e.target.closest('[data-cp-add]');
    if (a) { e.preventDefault(); cartPost('/cart/add.js', { items: [{ id: +a.getAttribute('data-cp-add'), quantity: 1 }] }); }
  });
  document.addEventListener('change', function (e) {
    var uvs = e.target.closest('[data-cp-upvar]');
    if (uvs) {
      var row = uvs.closest('.cp-cd__up'), sw = row && row.querySelector('[data-cp-upsw]');
      if (sw) { sw.setAttribute('data-cp-upsw', uvs.value); if (sw.checked) cartPost('/cart/change.js', { id: sw.getAttribute('data-key'), quantity: 0 }).then(function () { cartPost('/cart/add.js', { items: [{ id: +uvs.value, quantity: 1 }] }); }); }
      return;
    }
    var u = e.target.closest('[data-cp-upsw]');
    if (u) {
      var vs = u.closest('.cp-cd__up') && u.closest('.cp-cd__up').querySelector('[data-cp-upvar]');
      if (u.checked) cartPost('/cart/add.js', { items: [{ id: +(vs ? vs.value : u.getAttribute('data-cp-upsw')), quantity: 1 }] });
      else cartPost('/cart/change.js', { id: u.getAttribute('data-key'), quantity: 0 });
      return;
    }
    var p = e.target.closest('[data-cp-prot]');
    if (!p) return;
    try { localStorage.setItem('cp_noprot', p.checked ? '0' : '1'); } catch (x) {}
    if (p.checked) cartPost('/cart/add.js', { items: [{ id: +p.getAttribute('data-cp-prot'), quantity: 1 }] });
    else cartPost('/cart/change.js', { id: p.getAttribute('data-key'), quantity: 0 });
  });

  /* ---------- tabs ---------- */
  $$('[data-cp-tabs]').forEach(function (w) {
    var bs = $$('[data-tab]', w), ps = $$('.cp-tabs__pane', w);
    bs.forEach(function (b, i) { b.addEventListener('click', function () { bs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); ps[k].classList.toggle('is-on', k === i); }); }); });
  });

  /* ---------- short muted loops play only while on screen ---------- */
  var iv = $$('[data-cp-inview] video');
  if (iv.length && 'IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (en) { en.forEach(function (e) { var v = e.target; if (e.isIntersecting) { v.preload = 'auto'; v.play().catch(function () {}); } else v.pause(); }); }, { threshold: .35 });
    iv.forEach(function (v) { v.muted = true; vo.observe(v); });
  }

  /* ---------- product page ---------- */
  var pdp = $('[data-cp-pdp]');
  if (!pdp) return;
  var form = $('[data-cp-form]', pdp), atc = $('[data-atc]', pdp), err = $('[data-cp-err]', pdp);
  var curTpl = $('.cp-cur', pdp);

  function money(cents) {
    var w = Math.floor(cents / 100), r = cents % 100;
    var cur = curTpl ? curTpl.outerHTML : 'ر.س ';
    return '<span class="cp-price">' + cur + '<span class="cp-amt">' + w + (r ? '.' + ('0' + r).slice(-2) : '') + '</span></span>';
  }
  function moneyWas(c) { return money(c).replace('class="cp-price"', 'class="cp-price cp-price--was"'); }

  /* gallery */
  var gal = $('[data-cp-gal]', pdp), track = gal && $('[data-track]', gal), thumbs = gal ? $$('[data-go-to]', gal) : [];
  function goSlide(i) { if (!track) return; var s = track.children[i]; if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
  function curSlide() { if (!track) return 0; var w = track.clientWidth || 1; return Math.round(Math.abs(track.scrollLeft) / w); }
  if (track) {
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { var i = curSlide(); thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goSlide(+t.getAttribute('data-go-to')); }); });
    var pv = $('[data-prev]', gal), nx = $('[data-next]', gal), n = track.children.length;
    /* back arrow only from the 2nd picture; next arrow on the last picture goes back to the first */
    function navState() { var i = curSlide(); if (pv) pv.classList.toggle('is-off', i <= 0); }
    if (pv) pv.addEventListener('click', function () { goSlide(Math.max(0, curSlide() - 1)); });
    if (nx) nx.addEventListener('click', function () { goSlide((curSlide() + 1) % n); });
    track.addEventListener('scroll', function () { requestAnimationFrame(navState); }, { passive: true });
    navState();
  }

  /* bundle choice */
  var priceEl = $('[data-price]', pdp), wasEl = $('[data-was]', pdp), offEl = $('[data-off]', pdp), offN = $('[data-off-n]', pdp), stickyP = $('[data-sticky-price]');
  function chosen() { return $('input[name="id"]:checked', form) || $('input[name="id"]', form); }
  function update(scroll) {
    var r = chosen(); if (!r) return;
    var p = +r.getAttribute('data-price'), w = +r.getAttribute('data-was');
    if (priceEl) priceEl.innerHTML = money(p);
    if (stickyP) stickyP.innerHTML = money(p);
    if (wasEl && offEl) {
      if (w > p) { wasEl.hidden = false; wasEl.innerHTML = moneyWas(w); offEl.hidden = false; offN.textContent = Math.round((w - p) * 100 / w); }
      else { wasEl.hidden = true; offEl.hidden = true; }
    }
    var mid = r.getAttribute('data-media');
    if (scroll && mid && track) { $$('.cp-gal__slide', track).forEach(function (s, i) { if (s.getAttribute('data-media-id') === mid) goSlide(i); }); }
    if (scroll && window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u.toString()); }
  }
  $$('input[name="id"]', form).forEach(function (r) { r.addEventListener('change', function () { update(true); }); });

  /* add-on variant selects */
  $$('[data-addon-variant]', form).forEach(function (s) {
    s.addEventListener('change', function () { var cb = $('[data-addon]', s.closest('.cp-addon')); if (cb) { cb.setAttribute('data-addon', s.value); cb.checked = true; } });
  });

  /* add to cart */
  function busy(on) { [atc, $('[data-sticky-go]')].forEach(function (b) { if (b) b.classList.toggle('is-loading', on); }); }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var r = chosen(); if (!r) return;
    var items = [{ id: +r.value, quantity: 1 }];
    /* Seal: free-delivery box ticked + variant has a selling plan -> renewing subscription (like Sport Plus) */
    var gbox = $('[data-gift]', form), planId = +r.getAttribute('data-plan') || 0, isSub = !!(gbox && gbox.checked && planId);
    if (isSub) items[0].selling_plan = planId;
    $$('[data-addon]', form).forEach(function (cb) { if (cb.checked) items.push({ id: +cb.getAttribute('data-addon'), quantity: 1 }); });
    var gift = $('[data-gift]', form);
    var drawer = document.querySelector('cart-drawer');
    var go = pdp.getAttribute('data-go');
    busy(true); if (err) err.hidden = true;
    var pre = gift && gift.checked
      ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'تغليف هدية': 'نعم' } }) })
      : Promise.resolve();
    /* shipping protection comes preselected (like Sport Plus) unless the shopper switched it off in the cart */
    var protId = +form.getAttribute('data-prot') || 0, noProt = false;
    try { noProt = localStorage.getItem('cp_noprot') === '1'; } catch (x) {}
    if (protId && !noProt) pre = pre.then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items.some(function (i) { return i.variant_id === protId; })) {
        var pi = { id: protId, quantity: 1 }, pp = +form.getAttribute('data-prot-plan') || 0;
        if (isSub && pp) pi.selling_plan = pp;
        items.push(pi);
      }
    }).catch(function () {}); });
    /* free home delivery checkbox -> adds the free shipping line to the cart as a gift (like Sport Plus) */
    var freeId = gift && gift.checked ? +gift.getAttribute('data-free') || 0 : 0;
    if (freeId) pre = pre.then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items.some(function (i) { return i.variant_id === freeId; })) { var fi = { id: freeId, quantity: 1 }, fa = (window.cpSubAddons || []).filter(function (a) { return a.v === freeId; })[0]; if (isSub && fa) fi.selling_plan = fa.p; items.push(fi); }
    }).catch(function () {}); });
    pre.then(function () {
      var body = { items: items };
      if (drawer && go !== 'checkout') { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    }).then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok) throw new Error(x.j && (x.j.description || x.j.message) || 'error');
        if (go === 'checkout') { location.href = '/checkout'; return; }
        if (drawer && x.j.sections) { drawer.renderContents(x.j); busy(false); return; }
        location.href = '/cart';
      })
      .catch(function (ex) { busy(false); if (err) { err.textContent = 'صار خطأ بسيط، جرّب مرة ثانية'; err.hidden = false; } console.warn(ex); });
  });

  /* header hides on scroll down, shows on scroll up; back-to-top button (Sport Plus behaviour) */
  (function () {
    var hdr = document.querySelector('.cp-hdr'), last = scrollY, tt = document.createElement('button');
    tt.className = 'cp-totop'; tt.type = 'button'; tt.setAttribute('aria-label', 'للأعلى');
    tt.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6"/></svg>';
    tt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(tt);
    addEventListener('scroll', function () {
      var y = scrollY;
      if (hdr) hdr.classList.toggle('is-up', y > 200 && y > last);
      tt.classList.toggle('is-on', y > 900);
      last = y;
    }, { passive: true });
  })();

  /* sticky bar */
  var sticky = $('[data-cp-sticky]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      var hide = en[0].isIntersecting || en[0].boundingClientRect.top > 0;
      sticky.classList.toggle('is-on', !hide);
      document.body.classList.toggle('cp-has-sticky', !hide);
    });
    io.observe(atc);
    var sg = $('[data-sticky-go]', sticky);
    if (sg) sg.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
  }
  update(false);
  /* always open the gallery on the first picture (never jump to a bundle image) */
  if (track) {
    var home = function () { track.scrollLeft = 0; thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === 0); }); };
    home(); requestAnimationFrame(home); window.addEventListener('load', home); window.addEventListener('pageshow', home);
  }
})();

/* quick add (home page): most expensive bundle + free shipping + protection (+ bracelet if switched on), then open the cart drawer */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cp-quick-go]'), box = b && b.closest('[data-cp-quick]');
    /* red "order now" buttons that link to the perfume page: add to the side cart instead of leaving the page (like Sport Plus) */
    if (!b) {
      var a = e.target.closest('a.cp-btn, a.lx-btn, a.cp-pw__btn, a.cp-ctab__btn'); if (!a || e.metaKey || e.ctrlKey) return;
      var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
      if (u.host !== location.host || !/^\/products\/cupid\/?$/.test(u.pathname)) return;
      box = document.getElementById('cp-quick-global'); if (!box) return;
      e.preventDefault(); b = a;
      var md = a.closest('.cp-drawer'); if (md) { md.classList.remove('is-open'); md.setAttribute('aria-hidden', 'true'); }
    }
    if (!box || b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    var main = +box.getAttribute('data-main'), free = +box.getAttribute('data-free') || 0, prot = +box.getAttribute('data-prot') || 0;
    var noProt = false; try { noProt = localStorage.getItem('cp_noprot') === '1'; } catch (x) {}
    var up = box.querySelector('[data-cp-quick-up]'), sel = box.querySelector('[data-cp-quick-var]');
    fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }).then(function (c) {
      var has = function (id) { return c.items.some(function (i) { return i.variant_id === id; }); };
      var fbox = box.querySelector('[data-cp-quick-free]'), qplan = +box.getAttribute('data-plan') || 0, qsub = !!(qplan && (!fbox || fbox.checked));
      var items = [{ id: main, quantity: 1 }];
      if (qsub) items[0].selling_plan = qplan;
      var fcb = box.querySelector('[data-cp-quick-free]');
      if (free && (!fcb || fcb.checked) && !has(free)) { var qf = { id: free, quantity: 1 }, qfa = (window.cpSubAddons || []).filter(function (a) { return a.v === free; })[0]; if (qsub && qfa) qf.selling_plan = qfa.p; items.push(qf); }
      if (prot && !noProt && !has(prot)) { var qp = { id: prot, quantity: 1 }, qpp = +box.getAttribute('data-prot-plan') || 0; if (qsub && qpp) qp.selling_plan = qpp; items.push(qp); }
      if (up && up.checked) items.push({ id: +(sel ? sel.value : up.value), quantity: 1 });
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      var add = function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j, drawer: drawer }; }); }); };
      /* an old cart can be stuck on a country outside the market -> move it to Saudi Arabia and retry once */
      return add().then(function (x) { return x.ok ? x : cpSetSA().then(add); });
    }).then(function (x) {
      b.classList.remove('is-loading');
      if (!x.ok) throw new Error(x.j && (x.j.description || x.j.message) || ('HTTP error'));
      cpOpenDrawer(x.drawer, x.j);
    }).catch(function (ex) {
      b.classList.remove('is-loading'); console.warn(ex);
      var e = box.querySelector('.cp-bfx__err'); if (!e) { e = document.createElement('p'); e.className = 'cp-bfx__err'; b.insertAdjacentElement('afterend', e); }
      e.textContent = 'ما انضاف للسلة: ' + (ex && ex.message || 'خطأ') + ' – جرّب مرة ثانية';
    });
  });
})();

/* open the side cart with fresh contents; never navigate away (falls back to re-fetching the drawer section) */
function cpOpenDrawer(drawer, j) {
  if (!drawer) { location.href = '/cart'; return; }
  drawer.classList.remove('is-empty');
  var done = false;
  try { if (j && j.sections) { drawer.renderContents(j); done = true; } } catch (e) { console.warn(e); }
  if (done) { setTimeout(function () { if (!drawer.classList.contains('active')) try { drawer.open(); } catch (e) {} }, 400); return; }
  fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sec) {
    try { drawer.renderContents({ sections: sec }); } catch (e) {
      var tmp = document.createElement('div'); tmp.innerHTML = sec['cart-drawer'];
      var fresh = tmp.querySelector('#CartDrawer'), cur = drawer.querySelector('#CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      try { drawer.open(); } catch (e2) { drawer.classList.add('active'); }
    }
  }).catch(function () { location.href = '/cart'; });
}

function cpSetSA() {
  var f = new FormData(); f.append('form_type', 'localization'); f.append('_method', 'put'); f.append('country_code', 'SA'); f.append('return_to', '/');
  return fetch('/localization', { method: 'POST', body: f, credentials: 'same-origin' }).catch(function () {});
}
